export default function About() {
    return (
        <section
            id="maison"
            data-testid="about"
            className="py-32 bg-[#FAF9F6] relative"
        >
            <div className="max-w-[1500px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
                <div className="lg:col-span-5 section-fade">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[#B89C6A]" />
                        <span className="tracking-luxe text-[#B89C6A]">
                            La Maison CM RENOV
                        </span>
                    </div>
                    <h2 className="font-serif-lux text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                        Une maison d'artisans, <em className="italic text-[#B89C6A]">au service</em> des lieux d'exception.
                    </h2>
                </div>

                <div className="lg:col-span-7 lg:pt-6 section-fade space-y-6 text-[15px] leading-relaxed text-[#1C1E1D]/80">
                    <p>
                        Installée au 61 Avenue de Breteuil, dans le 7ème arrondissement de Paris, la Maison CM RENOV a vu le jour en <b>2024</b> avec une spécialisation claire : la <b>construction de maisons individuelles haut de gamme</b> — appuyée sur les matériaux et technologies nouvelle génération — et la <b>rénovation haut de gamme</b> mariant matériaux nobles (bois massif, pierre naturelle, marbre) et applications contemporaines.
                    </p>

                    {/* Founder credential */}
                    <div className="my-8 p-6 border-l-2 border-[#B89C6A] bg-[#B89C6A]/5">
                        <div className="tracking-luxe text-[#B89C6A] mb-3">
                            Le fondateur
                        </div>
                        <p className="font-serif-lux text-xl md:text-2xl leading-snug text-[#1C1E1D]">
                            <em>« Plus de 20 années dans le BTP, dont plusieurs comme cadre au sein d'un grand groupe du bâtiment. »</em>
                        </p>
                        <p className="mt-3 text-[13px] text-[#1C1E1D]/70">
                            C'est cette expertise éprouvée sur des chantiers d'envergure — méthodes, exigence, gestion — qui fonde aujourd'hui le regard singulier de CM RENOV : celui d'un artisan avec la rigueur d'un grand groupe.
                        </p>
                    </div>

                    <p>
                        Chaque chantier est piloté par un chargé d'affaires unique. De la conception au dernier coup de pinceau, un même interlocuteur veille au respect du geste artisanal, des délais et de la discrétion attendue par nos clients.
                    </p>
                    <p>
                        Nos compagnons — maçons, charpentiers, couvreurs, ébénistes, électriciens, peintres décorateurs — perpétuent un savoir-faire mêlant traditions séculaires et innovations les plus récentes.
                    </p>

                    <div className="grid grid-cols-3 gap-6 pt-10 mt-4 border-t hairline">
                        {[
                            { k: "Année", v: "2024" },
                            { k: "Assurance", v: "Décennale · RC Pro" },
                            { k: "Assureur", v: "France Assurances" },
                        ].map((i) => (
                            <div key={i.k}>
                                <div className="tracking-luxe text-[#B89C6A]">
                                    {i.k}
                                </div>
                                <div className="font-serif-lux text-xl mt-2">
                                    {i.v}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
